'use es6';

import { createSelector } from 'reselect';
import { getMatchHubDbRowId } from './matchSelectors';
import HubDbRow from '../models/HubDbRow';
export const getHubDbRows = state => state.hubDbRows;
export const getHubDbTable = state => state.hubDbTable;
export const getHubDbRowsStatus = createSelector([getHubDbRows], hubDbRows => hubDbRows.status);
export const getHubDbTableStatus = createSelector([getHubDbTable], hubDbTable => hubDbTable.status);
const getHubDbTableByName = setting => createSelector([getHubDbTable], hubDbTable => hubDbTable.getIn(['data', setting]));
export const getHubDbTableName = getHubDbTableByName('label') || getHubDbTableByName('name');
export const getHubDbRowsRows = createSelector([getHubDbRows], hubDbRows => hubDbRows.rows);
const getHubDbRowById = (rows, rowId) => rows.find(({
  id
}) => id === rowId, null, new HubDbRow());
const getHubDbCurrentRow = createSelector([getHubDbRowsRows, getMatchHubDbRowId], getHubDbRowById);
const getHubDbCurrentNameByName = setting => createSelector([getHubDbCurrentRow], row => row[setting]);
export const getHubDbRowName = getHubDbCurrentNameByName('name');
export const getHubDbRowPath = getHubDbCurrentNameByName('path');